import axios from 'axios'
import store from '@/store'
import * as Constants from './constants'
import { Message } from 'element-ui'
import context from '../main.js'

export default {
  init() {
    // 设置baseUrl
    axios.defaults.baseURL = ""//Constants.SERVER_HOST
    // 添加请求头
    axios.defaults.headers['fitness-appId'] = '2001'
    // 发送凭证
    axios.defaults.withCredentials = true
    // 拦截请求
    axios.interceptors.request.use(function (config) {
      store.commit('incrementLoading')
      config.headers["token-admin"] = localStorage.getItem("token-admin")
      config.headers["token-dealer"] = localStorage.getItem("token-dealer")
      config.headers["token-shop"] = localStorage.getItem("token-shop")
      config.headers["token-staff"] = localStorage.getItem("token-staff")
      config.headers["lang"] = context.$i18n.locale
      return config
    }, function (error) {
      store.commit('decrementLoading')
      return Promise.reject(error)
    })

    axios.interceptors.response.use(function (response) {
      store.commit('decrementLoading')
      // 显示错误消息
      if (response.data && !response.data.errorCode == 0) {
        Message({
          showClose: true,
          message: response.data.message,
          type: 'error'
        })
        // 处理登录超时
        if (response.data.errorCode === 5001) {
          store.commit('logout')
        }
      }

      return response
    }, function (error, err2) {
      store.commit('decrementLoading')
      Message({
        showClose: true,
        message: '网络错误,请稍后再试！',
        type: 'error'
      })
      if (store.state.isLogin === false) {
        //store.commit('logout')
      }
      return Promise.reject(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/config/AxiosConfig.js